import styled from "styled-components";

interface ITabItem {
  id: number;
  label: string;
}
interface Props {
  items: ITabItem[];
  activeId: number;
  onTabChange: (id: number) => void;
}

export default function TabButton({ items, activeId, onTabChange }: Props) {
  return (
    <Ul>
      {items.map((item) => (
        <Li key={item.id}>
          <Button $active={item.id === activeId} onClick={() => onTabChange(item.id)}>
            {item.label}
          </Button>
        </Li>
      ))}
    </Ul>
  );
}

const Ul = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  list-style: none;
`;

const Li = styled.li`
  padding: 20px;
`;

const Button = styled.button<{ $active: boolean }>`
  border: none;
  background: transparent;
  cursor: pointer;
  text-underline-offset: 22px;
  text-decoration: ${({ $active, theme }) => ($active ? `underline ${theme.colors.primary} 2px` : "none")};
  color: ${({ $active, theme }) => ($active ? theme.colors.primary : theme.colors.text.grayDark)};

  &:hover {
    color: ${({ theme }) => theme.colors.text.default};
  }
`;
